import { SPECIAL_CURRENCY_ID } from './player'

export enum EXCHANGE_ITEM_COST_TYPE {
  FREE = 'free',
  SPECIAL_CURRENCY = 'specialCurrency',
  STAR = 'star',
}

type ExchangeItemCostFree = {
  type: EXCHANGE_ITEM_COST_TYPE.FREE
}

type ExchangeItemCostSpecialCurrency = {
  type: EXCHANGE_ITEM_COST_TYPE.SPECIAL_CURRENCY
  currencyId: SPECIAL_CURRENCY_ID
  amount: number
}

type ExchangeItemCostUSD = {
  type: EXCHANGE_ITEM_COST_TYPE.STAR
  amount: number
  usdAmount: number
}

export type ExchangeItemCost = ExchangeItemCostFree | ExchangeItemCostSpecialCurrency | ExchangeItemCostUSD

export type ExchangeItemReward = {
  spins: number
  goldenCoins: number
  giveawayTickets: number
  dropeeStars: number
  specialCurrencies: Partial<Record<SPECIAL_CURRENCY_ID, number>> & Record<string, number>
  profitX2: number
  offlineProfit: number
}

export type ExchangeItem = {
  cost: ExchangeItemCost
  reward: Partial<ExchangeItemReward>
}

export type ExchangeConfig = {
  items: Record<string, ExchangeItem>
}

export type Exchange = {
  id: string
  name: string
  from: number
  to: number
  config: ExchangeConfig
}
